// extracted by mini-css-extract-plugin
export default {"wrapper":"AnalysisDetail_wrapper__KPeRu"};